import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_CreateFakeUser = _resolveComponent("CreateFakeUser")!
  const _component_v_window = _resolveComponent("v-window")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_v_progress_circular, {
          key: 0,
          indeterminate: "",
          color: "primary",
          class: "mr-3"
        }))
      : (_openBlock(), _createBlock(_component_v_window, {
          key: 1,
          modelValue: _ctx.currentStep,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.currentStep) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_window_item, { value: "selectUsers" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, {
                  "no-gutters": "",
                  style: {"flex-wrap":"nowrap","gap":"8px"},
                  class: "pb-2 justify-start"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "auto",
                      class: "d-flex my-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          size: "small",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.currentStep = 'createUser'))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("buttons.ajouter")), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "auto",
                      class: "d-flex my-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          size: "small",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.saveMailSubscription()))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("buttons.enregistrer")), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "auto",
                      class: "d-flex my-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          size: "small",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.subscribeEveryone()))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("buttons.selectionner-tout")), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "auto",
                      class: "d-flex my-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          size: "small",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.unSubscribeEveryone()))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("buttons.deselectionner-tout")), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_list, {
                  subheader: "",
                  style: {"max-height":"65vh","overflow-y":"auto"},
                  lines: "one"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listUsers, (user, i) => {
                      return (_openBlock(), _createBlock(_component_v_list_item, {
                        key: i,
                        class: "rounded-xl border-thin mb-2"
                      }, {
                        append: _withCtx(() => [
                          _createElementVNode("span", null, _toDisplayString(_ctx.getUserBigram(user)), 1)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_row, { "no-gutters": "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, {
                                cols: "6",
                                class: "d-flex align-center"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(user.email), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_v_col, {
                                cols: "6",
                                class: "d-flex align-center pl-4"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(user.firstname) + " " + _toDisplayString(user.lastname), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_checkbox, {
                            class: "d-flex align-center",
                            modelValue: user.isSubscribe,
                            "onUpdate:modelValue": ($event: any) => ((user.isSubscribe) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_window_item, { value: "createUser" }, {
              default: _withCtx(() => [
                _createVNode(_component_CreateFakeUser, {
                  isBack: true,
                  companyId: _ctx.companyId,
                  actions: _ctx.actions,
                  onAddUser: _ctx.addNewUser,
                  onBack: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goBack()))
                }, null, 8, ["companyId", "actions", "onAddUser"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]))
  ]))
}